import { render, staticRenderFns } from "./MergePatientData.vue?vue&type=template&id=0092b9a8&scoped=true&"
import script from "./MergePatientData.vue?vue&type=script&lang=js&"
export * from "./MergePatientData.vue?vue&type=script&lang=js&"
import style0 from "./MergePatientData.vue?vue&type=style&index=0&id=0092b9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0092b9a8",
  null
  
)

export default component.exports